import { render, staticRenderFns } from "./PersonalSpace-account-edit.vue?vue&type=template&id=3436ef0a&"
import script from "./PersonalSpace-account-edit.vue?vue&type=script&lang=js&"
export * from "./PersonalSpace-account-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports